import type {NameVariantValue} from 'schemaDefinition/types';

export const compareNameVariants = (
  a: NameVariantValue,
  b: NameVariantValue,
): boolean => {
  if (nullAsEmptyString(a.name) !== nullAsEmptyString(b.name)) return false;
  if (nullAsEmptyString(a.surName) !== nullAsEmptyString(b.surName))
    return false;
  if (nullAsEmptyString(a.addition) !== nullAsEmptyString(b.addition))
    return false;
  if (nullAsEmptyString(a.regnalNumber) !== nullAsEmptyString(b.regnalNumber))
    return false;

  return true;
};

/**
 * Some of the fields are conditional, so they might come as both undefined, null or an empty string.
 * All of these conditions should match as equal.
 */
const nullAsEmptyString = (value: string | null | undefined): string => {
  if (typeof value === 'string') return value;

  return '';
};
